
import { cn } from '@/lib/utils';
import { painelDescriptionClass, painelDescriptionMutedClass } from '@/components/painel/painel-styles';

type AnalyticsPageChromeProps = {
  title: string;
  description?: string;
  children?: React.ReactNode;
  actions?: React.ReactNode;
};

export function AnalyticsPageChrome({ title, description, children, actions }: AnalyticsPageChromeProps) {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0 space-y-1">
          <p className="font-inter text-[10px] font-bold uppercase tracking-[0.2em] text-sky-300/55">
            Analytics
          </p>
          <h1 className="font-poppins text-2xl font-bold tracking-tight text-white md:text-3xl">{title}</h1>
          {description ? (
            <p className={cn('max-w-2xl font-inter text-sm', painelDescriptionClass)}>{description}</p>
          ) : null}
        </div>
        {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}

type AnalyticsPanelProps = {
  title: string;
  subtitle?: string;
  className?: string;
  children: React.ReactNode;
  /** Conteúdo extra à direita do cabeçalho (filtros, rótulos). */
  headerRight?: React.ReactNode;
};

export function AnalyticsPanel({ title, subtitle, className, children, headerRight }: AnalyticsPanelProps) {
  return (
    <section
      className={cn(
        'rounded-2xl border border-white/10 bg-blue-950/40 shadow-[0_0_40px_-14px_rgba(56,189,248,0.12)] backdrop-blur-md',
        className
      )}
    >
      <div className="flex flex-col gap-2 border-b border-white/[0.07] px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <h2 className="font-poppins text-sm font-semibold text-white">{title}</h2>
          {subtitle ? (
            <p className={cn('mt-0.5 font-inter text-xs', painelDescriptionMutedClass)}>{subtitle}</p>
          ) : null}
        </div>
        {headerRight}
      </div>
      <div className="p-5">{children}</div>
    </section>
  );
}

type AnalyticsBadgeProps = { children: React.ReactNode };

export function AnalyticsPeriodBadge({ children }: AnalyticsBadgeProps) {
  return (
    <span className="inline-flex items-center rounded-lg border border-sky-400/25 bg-sky-500/[0.12] px-2.5 py-1 font-poppins text-[11px] font-semibold uppercase tracking-wider text-sky-100/90">
      {children}
    </span>
  );
}
